import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { injectViewportBreakpoints } from '@quipex/core/utils';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'form[qpx-filters]',
    templateUrl: './filter-bar.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-filter-bar @container',
        '[attr.data-testid]': '`${containerId()}-filters`',
        'aria-label': 'Filters',
        '(submit)': '$event.preventDefault()',
    },
})
export class QpxFilterBar {
    private readonly viewport = injectViewportBreakpoints();
    public readonly overlaySearch = this.viewport.lessThan('desktop');
    public readonly containerId = input.required<string>();
}
